import { combineReducers } from 'redux';
import authReducerSlice from '@auth/redux/reducer';
import groupsReducerSlice from './baskets/redux/reducer';
import groupDetailsReducerSlice from './basketDetails/redux/reducer';
import createGroupReducerSlice from './createBasket/redux/reducer';
import profileDetailsReducerSlice from './profile/redux/reducer';
import updateGroupReducerSlice from './updateBasket/redux/reducer';
import basketReducerSlice from './basket/redux/reducer';
import ordersReducer from './orderHistory/redux/reducer';
import productsReducerSlice from './products/redux/reducer';
import recipesReducerSlice from './recipes/redux/reducer';
import recipeReducerSlice from './recipe/redux/reducer';
import mealReducerSlice from './Meal/redux/reducer';
import partnerReducerSlice from './marketplace/redux/reducer';
import sellersReducers from './sellers/redux/reducer';
import productReducer from './product/redux/reducer';

const rootReducers = combineReducers({
  auth: authReducerSlice,
  groups: groupsReducerSlice,
  groupDetails: groupDetailsReducerSlice,
  createGroup: createGroupReducerSlice,
  profileDetails: profileDetailsReducerSlice,
  updateGroup: updateGroupReducerSlice,
  basket: basketReducerSlice,
  recipes: recipesReducerSlice,
  recipe: recipeReducerSlice,
  order_history: ordersReducer,
  products: productsReducerSlice,
  meal: mealReducerSlice,
  partner: partnerReducerSlice,
  sellers: sellersReducers,
  product: productReducer,
});

export default rootReducers;
